import { render, staticRenderFns } from "./ProjectChooseVolunteersReadOnlyView.vue?vue&type=template&id=dd1c5c36&scoped=true&"
import script from "./ProjectChooseVolunteersReadOnlyView.vue?vue&type=script&lang=js&"
export * from "./ProjectChooseVolunteersReadOnlyView.vue?vue&type=script&lang=js&"
import style0 from "./ProjectChooseVolunteersReadOnlyView.vue?vue&type=style&index=0&id=dd1c5c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1c5c36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VForm,VLayout})
